<nav class="tab-navigation" aria-label="Analysebereiche">
  @for (tab of tabs; track tab.id) {
    <button
      type="button"
      class="tab-item"
      [class.active]="activeTab === tab.id"
      [attr.aria-current]="activeTab === tab.id ? 'page' : null"
      (click)="tabChange.emit(tab.id)"
    >
      {{ tab.label }}
    </button>
  }
  @if (showInfoButton) {
    <app-v3-info-button [size]="20"></app-v3-info-button>
  }
</nav>
